<template>
  <div id="alert_modal" class="modal-wrap order_info">
    <div class="modal-container">
      <div class="modal_header">
        <div class="header_txt">
          <div>주문 상세</div>
        </div>
        <div class="od_txt">
          <div class="txt">
            주문일: <span v-html="formattedOrderedDate"></span>
          </div>
          <!-- <div class="txt">주문일: <span>2024. 07.07</span></div> -->

          <div class="txt">
            주문번호: <span v-html="detailResContent.order_no"></span>
          </div>
          <!-- <div class="txt">주문번호: <span>2024. 07.07</span></div> -->
        </div>
      </div>

      <div class="modal_body">
        <div class="modal_contents">
          <div class="purchase_con">
            <div class="purchase_header">
              <div>구매 항목</div>
              <div>금액</div>
            </div>
            <div class="items">
              <!-- for -->
              <div class="purchase_item">
                <div class="purchase_img">
                  <img :src="detailResContent.contents_thumbnail" />
                  <!-- <img
                    src="../../public/assets/images/layout/dummy_prd_img.png"
                  /> -->
                </div>
                <div class="purchase_details">
                  <!-- <div class="pd_title">콘텐츠명(예: 서버보안실습(관리))</div> -->
                  <div
                    class="pd_title"
                    v-html="detailResContent.contents_title"
                  ></div>

                  <div v-if="detailResContent.options">
                    <div
                      v-for="(option, index) in detailResContent.options"
                      class="pd_option"
                      :key="index"
                    >
                      <div class="opt_group">
                        <div class="opt_type">
                          <span v-if="option.name.includes('구독권')"
                            >콘텐츠</span
                          >
                          <span v-else> 추가옵션 </span>
                        </div>
                        <!-- <div>메타 퀘스트3 256GB 1개</div> -->
                        <div
                          v-if="
                            option.contents_subs_started_at !== '' &&
                            option.contents_subs_started_at !== null
                          "
                        >
                          <p v-html="option.name"></p>
                          <span
                            v-html="
                              option.contents_subs_started_at.slice(0, 10)
                            "
                          ></span>
                          ~
                          <span
                            v-html="option.contents_subs_ended_at.slice(0, 10)"
                          ></span>
                        </div>

                        <div v-else>
                          <p
                            v-html="option.name + ' - ' + option.count + '개'"
                          ></p>
                        </div>
                      </div>
                      <div class="price">
                        <span
                          v-html="
                            (
                              option.amt * option.count +
                              option.delivery_amt
                            ).toLocaleString()
                          "
                        ></span>
                        원
                        <div v-if="option.delivery_amt" class="deliv_fee">
                          <span
                            v-html="
                              '(배송비 : ' +
                              option.delivery_amt.toLocaleString() +
                              ' 원)'
                            "
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- for -->
            </div>

            <div v-if="detailResDelivery">
              <div class="purchase_header point_color">
                <div>배송 정보</div>
              </div>
              <div class="pay_method delivery_info">
                <div class="type top_part">배송 주소</div>
                <div v-if="detailResDelivery.zip !== ''" class="info bg_wihte">
                  <!-- <span v-html="detailResDelivery.zip"></span><br /> -->
                  <span
                    v-html="
                      '(' +
                      detailResDelivery.zip +
                      ') ' +
                      '&nbsp;' +
                      detailResDelivery.addr +
                      ', ' +
                      detailResDelivery.addr_detail
                    "
                  ></span>
                </div>
                <div v-else class="info bg_wihte">
                  <span>-</span>
                </div>
              </div>

              <div class="pay_method delivery_info">
                <div class="type top_part">주문자명</div>
                <div v-if="detailResDelivery.name !== ''" class="info bg_wihte">
                  <span v-html="detailResDelivery.name"></span>
                </div>
                <div v-else class="info bg_wihte">
                  <span>-</span>
                </div>
              </div>

              <div class="pay_method delivery_info">
                <div class="type top_part">연락처</div>
                <div v-if="detailResDelivery.tel !== ''" class="info bg_wihte">
                  <span v-html="detailResDelivery.tel"></span>
                </div>
                <div v-else class="info bg_wihte">
                  <span>-</span>
                </div>
              </div>

              <div class="pay_method delivery_info">
                <div class="type top_part">요청사항</div>
                <div
                  v-if="detailResDelivery.req_msg !== ''"
                  class="info bg_wihte"
                >
                  <span v-html="detailResDelivery.req_msg"></span>
                </div>
                <div v-else class="info bg_wihte">
                  <span>-</span>
                </div>
              </div>
            </div>

            <div class="purchase_header point_color">
              <div>결제 수단</div>
            </div>
            <div class="pay_method">
              <div class="type" v-html="detailResPayInfo.type"></div>
              <!-- <div class="type">신용카드</div> -->
              <div class="info">
                <!-- 
                  value_1
                  카드 : 카드사 (간편결제 : 결제사)
                  계좌 : 출금계좌
                  가상 : 입금 은행
                 -->
                <div v-html="detailResPayInfo.value_1"></div>
                <!--
                  value_2
                  카드 : 카드번호 (간편결제: 할부)
                  계좌 : 없음
                  가상 : 예금주
                -->
                <div v-html="detailResPayInfo.value_2"></div>
                <!--
                  value_3
                  카드 : 할부 (간편결제 : 없음)
                  계좌 : 없음
                  가상 : 계좌번호
                -->
                <!-- 카드 :: 값이 비어있지 않고, 영어로 시작하지 않는 경우 -->
                <!-- <div
                  v-if="
                    detailResPayInfo.value_3 &&
                    !startsWithEnglish(detailResPayInfo.value_3)
                  "
                >
                  <span v-html="detailResPayInfo.value_3"></span>개월
                </div> -->
                <!-- 가상 :: 영어로 시작하고 값이 비어있지 않은 경우 -->
                <!-- <div
                  v-else-if="
                    detailResPayInfo.value_3 &&
                    startsWithEnglish(detailResPayInfo.value_3)
                  "
                  v-html="detailResPayInfo.value_3"
                ></div> -->
                <!-- 계좌, 간편 :: 값이 비어있는 경우 -->
                <!-- <div v-else></div> -->
                <!-- <div v-html="detailResPayInfo.value_3"></div> -->

                <!-- 카드 :: -->
                <div v-if="detailResPayInfo.type === '신용카드'">
                  <span
                    v-if="typeof detailResPayInfo.value_3 === 'number'"
                    v-html="detailResPayInfo.value_3 + '개월'"
                  ></span>
                  <!-- !isNaN(Number(innerOrder)) -->
                  <!--     
                  <span v-if="innerOrder !== '' && 
                  !isNaN(Number(innerOrder))">{{ innerOrder }} 숫자!</span>
 -->
                  <span
                    v-if="
                      detailResPayInfo.value_3 !== '' &&
                      !isNaN(Number(detailResPayInfo.value_3))
                    "
                    v-html="detailResPayInfo.value_3 + '개월'"
                  ></span>
                  <span v-else v-html="detailResPayInfo.value_3"></span>
                </div>
                <!-- 가상 :: -->
                <div
                  v-else-if="
                    detailResPayInfo.type === '가상계좌' ||
                    detailResPayInfo.type === '간편결제'
                  "
                >
                  <span v-html="detailResPayInfo.value_3"></span>
                </div>
                <!-- 계좌, 간편 :: -->
                <div v-else>
                  <span v-html="detailResPayInfo.value_3"></span>
                </div>

                <!--
                  value_4
                  카드 : 없음 (간편결제 : 없음)
                  계좌 : 없음
                  가상 : 입금기한
                -->
                <div
                  v-if="
                    detailResPayInfo.type === '가상계좌' &&
                    detailResPayInfo.value_4
                  "
                >
                  입금기한: <span v-html="formattedPayEndDate"></span>
                </div>
                <div
                  v-if="
                    (detailResPayInfo.type === '신용카드' ||
                      detailResPayInfo.type === '계좌이체') &&
                    detailResPayInfo.approved_at
                  "
                >
                  결제시간: <span v-html="formattedApprovedDate"></span>
                </div>
                <!-- <div>일시불</div>
                <div>승인일시: 2024.07.07</div> -->
                <div
                  v-if="
                    detailResPayInfo.type === '가상계좌' &&
                    detailResPayInfo.ipgm_at !== ''
                  "
                >
                  입금완료시간: <span v-html="formattedIpgmAt"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="refundTxt">
        교환, 반품 신청, 환불 문의는 <a href="/inquiry">서비스 이용 문의</a>를
        통해 문의해주세요.
      </div>
      <div class="modal_footer">
        <div class="btn_area">
          <button
            v-if="detailResPayInfo.type === '신용카드'"
            class="btn_basic"
            @click="showBillCard"
          >
            카드 영수증
          </button>
          <button
            v-else-if="detailResPayInfo.type === '계좌이체'"
            class="btn_basic"
            @click="showBillAccount"
          >
            구매 영수증
          </button>
          <button
            v-else-if="
              detailResPayInfo.type === '가상계좌' &&
              detailResPayInfo.ipgm_at !== ''
            "
            class="btn_basic"
            @click="showBillVaccount"
          >
            구매 영수증
          </button>
          <button
            v-else-if="
              detailResPayInfo.type === '가상계좌' &&
              detailResPayInfo.ipgm_at === ''
            "
            class="btn_basic"
            @click="beforeDeposit()"
          >
            입금 전
          </button>
          <button class="btn_basic close_btn mt_0" @click="closeModal()">
            닫기
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="Modals">
    <ModalAlertOrder
      :alertMsg="errMsg"
      :isOpen="errStatus"
      @update:isOpen="updateStatus"
    />
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue'
// import { useRouter } from 'vue-router'
import { loadOrderDetailData } from '../api/orders'

import CustomSelect from './CustomSelect.vue'
import ModalAlertOrder from './ModalAlertOrder.vue'

export default {
  name: 'OrderInfo',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CustomSelect,
    ModalAlertOrder,
  },
  props: {
    isOpen: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    selectedNo: Object,
  },
  emits: ['update:isOpen'],
  setup(props, { emit }) {
    // eslint-disable-next-line no-undef
    // const router = useRouter()

    const errMsg = ref('')
    const errStatus = ref(false)
    const updateStatus = () => {
      errStatus.value = false
    }

    const modalCheck = ref('')
    const orderNo = ref('')
    const detilResponse = ref('')
    const detailResContent = ref('')
    const detailResPayInfo = ref('')
    const detailResDelivery = ref('')

    const orderedDate = ref('')
    const formattedOrderedDate = ref('')
    const payEndDate = ref('')
    const formattedPayEndDate = ref('')
    const approvedDate = ref('')
    const formattedApprovedDate = ref('')
    const ipgmAtDate = ref('')
    const formattedIpgmAt = ref('')

    watch(
      () => props.selectedNo, // watch 대상 변경
      (newVal) => {
        orderNo.value = newVal // selectedNo의 값으로 업데이트
      },
      { immediate: true } // 컴포넌트 마운트 시에도 즉시 실행
    )
    const getData = async () => {
      // console.log('getData안에서의 orderNo ::: ', orderNo.value)
      try {
        detilResponse.value = await loadOrderDetailData(orderNo.value)
        detailResContent.value = detilResponse.value.content
        detailResPayInfo.value = detilResponse.value.content.payment_method
        detailResDelivery.value = detilResponse.value.content.delivery
        // console.log(detailResContent.value)
        // console.log(detailResPayInfo.value)
        if (detilResponse.value.content.payment_date !== null) {
          orderedDate.value = detilResponse.value.content.payment_date
          const year = orderedDate.value.slice(0, 4)
          const month = orderedDate.value.slice(4, 6)
          const day = orderedDate.value.slice(6, 8)
          // const hour = orderedDate.value.slice(8, 10)
          // const minute = orderedDate.value.slice(10, 12)
          // const second = orderedDate.value.slice(12, 14)
          // formattedOrderedDate.value = `${year}-${month}-${day} ${hour}:${minute}:${second}`
          formattedOrderedDate.value = `${year} .${month} .${day}`
        }
        if (detailResPayInfo.value.value_4 !== null) {
          payEndDate.value = detailResPayInfo.value.value_4
          const year = payEndDate.value.slice(0, 4)
          const month = payEndDate.value.slice(4, 6)
          const day = payEndDate.value.slice(6, 8)
          const hour = payEndDate.value.slice(8, 10)
          const minute = payEndDate.value.slice(10, 12)
          const second = payEndDate.value.slice(12, 14)
          formattedPayEndDate.value = `${year} .${month} .${day} ${hour}:${minute}:${second}`
        }
        if (detailResPayInfo.value.approved_at !== null) {
          approvedDate.value = detailResPayInfo.value.approved_at
          const year = approvedDate.value.slice(0, 4)
          const month = approvedDate.value.slice(4, 6)
          const day = approvedDate.value.slice(6, 8)
          const hour = approvedDate.value.slice(8, 10)
          const minute = approvedDate.value.slice(10, 12)
          const second = approvedDate.value.slice(12, 14)
          formattedApprovedDate.value = `${year} .${month} .${day} ${hour}:${minute}:${second}`
        }
        if (detailResPayInfo.value.ipgm_at !== null) {
          ipgmAtDate.value = detailResPayInfo.value.ipgm_at
          const year = ipgmAtDate.value.slice(0, 4)
          const month = ipgmAtDate.value.slice(4, 6)
          const day = ipgmAtDate.value.slice(6, 8)
          const hour = ipgmAtDate.value.slice(8, 10)
          const minute = ipgmAtDate.value.slice(10, 12)
          const second = ipgmAtDate.value.slice(12, 14)
          // formattedApprovedDate.value = `${year} .${month} .${day} ${hour}:${minute}:${second}`
          formattedIpgmAt.value = `${year} .${month} .${day} ${hour}:${minute}:${second}`
          // ipgm_at
        }
      } catch (err) {
        console.log(err)
      }
    }
    // 영어 대소문자로 시작하는지 체크하는 정규식
    const startsWithEnglish = (value) => /^[a-zA-Z]/.test(value)
    const closeModal = () => {
      emit('update:isOpen', false)
    }
    const beforeDeposit = () => {
      errMsg.value = '입금 완료 후 구매 영수증을 확인할 수 있습니다.'
      errStatus.value = true
    }
    const showBillCard = () => {
      const billUrl = `https://admin8.kcp.co.kr/assist/bill.BillActionNew.do?cmd=card_bill&tno=${detailResContent.value.tno}&order_no=${detailResContent.value.order_no}&trade_mony=${detailResContent.value.total_amt}`
      window.open(billUrl, '_blank')
    }
    const showBillAccount = () => {
      const billUrl = `https://admin8.kcp.co.kr/assist/bill.BillActionNew.do?cmd=acnt_bill&tno=${detailResContent.value.tno}&order_no=${detailResContent.value.order_no}&trade_mony=${detailResContent.value.total_amt}`
      window.open(billUrl, '_blank')
    }
    const showBillVaccount = () => {
      const billUrl = `https://admin8.kcp.co.kr/assist/bill.BillActionNew.do?cmd=vcnt_bill&tno=${detailResContent.value.tno}&order_no=${detailResContent.value.order_no}&trade_mony=${detailResContent.value.total_amt}`
      window.open(billUrl, '_blank')
    }
    onMounted(() => {
      getData()
      // console.log('orderNo ::: ', orderNo.value)
    })
    return {
      errMsg,
      errStatus,
      updateStatus,

      modalCheck,
      orderNo,
      closeModal,
      beforeDeposit,
      detilResponse,
      detailResContent,
      detailResPayInfo,
      detailResDelivery,
      formattedOrderedDate,
      formattedPayEndDate,
      formattedApprovedDate,
      formattedIpgmAt,
      startsWithEnglish,

      showBillCard,
      showBillAccount,
      showBillVaccount,
    }
  },
}
</script>

<style></style>
